module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Sister’s Choice")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "9781460302989.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "content-type"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("B")])]), _vm._v("efore moving into the old mobile home parked at the back of Cashel Orchards, Cash Rosslyn had reluctantly painted the exterior—but only because at the rate the trailer was rusting, he was afraid one morning he might wake up in his birthday suit with nothing sheltering him except gnarled apple trees and the shoulder-high weeds he called his front yard. With the same level of interest, he had hauled away all the junk in view: the graveyard of farm machinery, the 1943 Studebaker, the disintegrating hay bales complete with mouse housing developments and, last but best, the still pungent dog run where generations of retrievers and hounds had waited impatiently for hunting season to begin.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The inside of the mobile home was another matter. After the first trip inside he had bombed it for fleas and roaches and every other critter that had set up housekeeping. He had hauled out the remnants of the last farmworker’s belongings, removed and replaced the old cheap paneling with new cheap paneling, then hired a neighbor woman to scrub the whole place from top to bottom.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That was the last time he had paid much attention to interior decorating.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This evening, of course, a woman decorated his interior, the only one who felt free to come and go as she pleased, who ignored his protests—if he even bothered. Grace Cashel sat on his secondhand sofa watching one of the three channels his malfunctioning satellite dish would part with. She didn’t look up as he opened the door.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sandra was disappointed you didn’t make it for Sunday supper,” she said, eyes still trained on the fuzzy images flickering across the screen.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I had a prior engagement. I told her way ahead of time I wouldn’t be there.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your mother is easily hurt.” Grace picked up the remote and turned down the volume a notch. “I hope this woman who intercepted you on the way to a family engagement was intelligent enough to chew with her mouth closed.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cash plopped down next to his grandmother and put his arm around her. “Just somebody I know from high school. We went for a pizza, and she didn’t stop talking long enough to chew, although she sure downed her share.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re lonely.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m fine. And I’m not the one sitting here watching somebody’s thirteen-inch TV set when she has a twenty-six-inch and a working satellite dish in her house up the hill.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Whenever I turn that one on, I can almost hear Ben insisting I change the channel. I swear he’s still living there. Some nights I just have to get away from him.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cash squeezed her shoulder. “What does he want to watch?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He’s prone to wrestling and anything with John Wayne. Oh, and cowboy movies. If he hadn’t had so many responsibilities as a young man, he would have taken off for Wyoming and a home on the range.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He never would have left you.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You might be surprised. I’m not always the easiest woman to live with.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No…” Cash let loose with a long, low whistle. “You, Granny Grace?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She uses cheap perfume.” She finally glanced at him. “Your pizza-eating chatterbox. I can smell it on you.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I told you, she’s an old friend from high school, and she just got divorced. She spent the whole night sitting beside me in a booth swallowing eight slices to my two and telling me every rotten thing her husband ever did to her.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your mother made roast chicken, mashed potatoes and green beans. Not an herb or garnish in sight. Last week I gave her my recipe for jerk seasoning, but apparently she was unimpressed.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve got a job for you.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His grandmother groaned. “I could swear I retired. Didn’t somebody somewhere give me a gold watch? I certainly deserved one.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did you keep up your permit for wildlife rehabilitation?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What have you gotten me into?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("another")]), _vm._v(" woman…”")]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The fawn was not easily forgotten. When bedtime rolled around, the girls demanded Jamie tell them a story about a deer. Jamie discounted all the ones she knew—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bambi")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Yearling")]), _vm._v(" certainly weren’t appropriate under the circumstances—and made up her own tale about a deer’s happy life in the forest. She was fairly certain they didn’t completely buy it, but by the time she had finished describing the many happy moments eating grass and leaves and destroying local vegetable gardens, they were fast asleep. Although she wanted to stay up and savor the quiet cabin, the chirping of crickets and a little time with the plans for Kendra and Isaac’s new house, she wasn’t far behind.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The next morning, the girls were up with the sun, demanding another trip into the forest. Dragging herself out of bed, she reminded them that Cash was coming later to help them look, so they had to wait. That did not make for peaceful conversation.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The telephone rang while she was getting eggs out of the refrigerator; Cash was on the other end. The call was brief. When she hung up, she recounted it to the girls.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That was Mr. Rosslyn. He’s coming over at nine with more wood for your playhouse. I told him we’d feed him breakfast.” She went back to the eggs. “And he’s bringing somebody to meet us.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He said it was a surprise, and they’d be here by nine.” Actually, what he had said was “I’d be happy to come, but would you mind if I brought somebody with me? I promise she eats like a bird.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie was intrigued. She had decided not to prod, since that was probably exactly what he’d expected. But with the challenge issued, she rummaged through the refrigerator again to see what she could make that would be more festive than scrambled eggs.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She decided on mushroom omelets, a simple fruit salad and surprise muffins. The surprise was two teaspoons of jam buried in the center, which Hannah and Alison loved to help with. Once the muffins were in the oven, she put Hannah in charge of peeling bananas and Alison in charge of folding napkins.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The movers had come late yesterday afternoon, piling most of the boxes in the girls’ room or on the back porch, and after dinner, Jamie had unpacked several and tidied the cabin. With some of their own things on display—framed finger paintings and photos, an afghan a First Step friend had crocheted and a carnival glass pitcher filled with wildflowers they had brought back from the orchard—the cabin seemed more like their own.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Once the muffins were out of the oven, she showered and changed while Hannah read to Alison. By age four, her daughter had gotten tired of waiting to be read to and had taught herself, with only the most perfunctory help. Now, at eight, Hannah read to her sister almost as often as Jamie did, although Alison was learning to figure out words, as well.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As she towel dried her flat abdomen, Jamie pondered how quickly her daughters were growing. Cash had seemed surprised at the differences, and she understood. Unless an onlooker was watching every moment, the changes could be startling. Sometimes, she mourned the loss of the cuddly, malleable infants and toddlers they had been.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She rested her hand on her belly for a moment, wondering how that belly would look after "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("three")]), _vm._v(" babies had grown inside her. Would men still find her attractive? How about somebody like Cash?")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Did she care?")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She smiled at that. She wasn’t even thirty, but her luck with men had been terrible. Of course, her ability to select men with an eye toward a stable future had been terrible, too. In her defense, early role models had been sorely lacking. As a child she had been a prime witness to her mother’s destructive relationships; then, as a teenager, she had been educated on city streets where nothing wholesome could flourish. The men who had crossed her path had been as lost and angry as she was.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Even when she finally began to rebuild her life, she had not chosen well. Neither of her daughters’ fathers were husband material. Imperfect birth control, not hopes for a loving family, had turned them into parents. Her heart had not broken when either man walked out of her life, although sometimes her heart broke for her girls, who needed more than financial support and their fathers’ reluctant visits.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So did she really care if the time came when men no longer gave her a second glance? If they looked at her hugely expanded body, no longer as likely to spring back into form after this third pregnancy, and turned away? Did she care if Cash lost all interest when he found out "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("why")]), _vm._v(" she was in Virginia?")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had no answer. She wasn’t ready to give up on men. Just because she’d habitually chosen losers didn’t mean that, somewhere, some man wasn’t routinely crossing the finish line ahead of the pack. On the other hand, she wasn’t sure she wanted any part of the race for a while, either.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Didn’t she have her hands full already?")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("From the great room she heard the patter of bare feet, then Alison’s loud giggles. She’d had her five minutes of contemplation. Both charmed and wary, she dressed quickly in a denim skirt and tank top, ran a brush through her hair and went to see what was up.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("By nine o’clock Hannah was providing running commentary from the front door.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s nine and they are not here.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s called being fashionably late.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“When is it fashionable, and when is it rude?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“When the muffins get stale it’s rude. That’s a long time yet.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There are not always muffins.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hannah, when you host a meal, even breakfast, you plan to eat some time after your guests arrive, to give them time to sit and chat, have something to drink, enjoy your company.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How long does that take?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Anywhere from half an hour to an hour, although shorter at breakfast time, and now I’m done with the entertainment tips.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I think I hear a truck. They are only—” Hannah glanced at a clock on the mantel “—two minutes late. Does that mean they are unfashionable?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, it just means that you’re watching the clock. Why don’t you go out and greet them?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Me, too!” Alison took off for the door after her sister.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie shook her head and hoped that whoever Cash’s guest was, she was up to the onslaught.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("By the time the girls came racing back, the muffins were arranged on a stoneware platter, a pitcher of tea sat on the counter next to a carafe of coffee and the fruit salad was adorned with sprigs of mint.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Cash and Granny Grace are here!” Hannah said.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Granny Grace?")]), _vm._v(" Of all the people Jamie had anticipated, Cash’s grandmother hadn’t been one of them. She stepped out from behind the breakfast bar just as one of the least grandmotherly-looking women she had ever seen crossed the threshold.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Granny Grace was tall, almost as tall as Cash, who entered behind her. She was willowy and slender, with iron-gray hair and sharp features. The features were belied by creases and folds around dancing dark eyes adorned with rectangular black-rimmed glasses. A wide mouth signaled decades of smiles and laughter.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The most extraordinary thing about the woman was her sense of style. Rarely had Jamie seen lime green and purple used together with such abandon. Harem pants billowed around her hips and tucked in at her ankle; a hip-length vest, sprinkled heavily with crystal beads, sparkled like a fireworks display. She wore gold tennis shoes, and her fingernails were a deep scarlet that matched her lipstick.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Judging by the wrinkles and the patches of scalp visible under spiky hair, this woman "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("could")]), _vm._v(" well be someone’s granny. But judging by her bouncing step, her flamboyance and obvious delight with life, she was a teenager.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What exactly did it say about a man when he brought his grandmother to visit?")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You must be Jamie.” Granny Grace extended her hand. “Let the rest of them call me Granny Grace. You call me Grace.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie shook, impressed by the strength of the narrow, age-spotted hand. “I’m so glad to have you here. Cash didn’t tell me exactly who he was bringing. Now I can thank you for the pie.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Cash is a rogue and a renegade. It skipped a generation. His mother is as tightly reined in as a carriage horse. Sandra’s a good daughter, mind you, but I was thrilled to see the mischief emerge again in this one. Until he came along, I was afraid all my genes had been flushed down the eternal toilet.” She nodded toward Cash. “Although he could do with some breaking in.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie laughed. “I bet if anybody could do it, you’d be the one.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your oldest daughter has your dimples. She’s your spitting image. Was there a father?” She waved away her own question. “Never mind. Clearly there had to be, but he didn’t leave much of a footprint, did he? Now the other one? The leprechaun princess? Not a bit of you in the face, but I bet you had that same amount of energy and enthusiasm as a child.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll have to ask my sister. She would know.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t bother. I can see it in your eyes. I’m not fond of women who look like everything’s been washed out of them.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cash put his hand on his grandmother’s shoulder. “Granny Grace has no real opinions about anything.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There’s no reason to keep what I’ve learned to myself, dear. I need to share, share, share while I can.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie was enchanted. Normally she was suspicious of outrageous women. Her mother was all flash and dazzle, with little under the rhinestone exterior to anchor her to reality. But Grace had already paid close attention to Jamie’s children and made connections. Jamie thought this was a woman who probably paid close attention to everything and everyone.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So what do you think of the cabin?” Cash asked his grandmother.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I think it’s a lovely little postage stamp, and I think these girls are going to need that playhouse you’re building for them, so their poor mother can breathe a little. I suggest turrets and portholes and places to hide secret messages.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cash’s gaze swung to Jamie’s. “If I didn’t know better, I’d say there’s a conspiracy brewing.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And we just met.” Jamie flashed the dimples that were exactly like Hannah’s. “Just think what kind of trouble we’ll get into when we’ve known each other a week.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grace did not eat like a bird. She ate the way she dressed, with gusto. Once she was seated at the table, she listened raptly as the girls explained how they had helped with the muffins. She asked for seconds on the omelet and stole more off Cash’s plate when he wasn’t looking. The fruit salad interested her most of all.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There’s not an apple anywhere,” she said. “It’s delicious just as it is, of course. And eye pleasing. Food that looks good is as important as food that tastes good. I can see you know that already, but where are the apples?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t like Red Delicious, and that’s all they had at the grocery store. It’s too early for the local apples at the fruit stand.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I knew you had excellent taste. You have, after all, already become friends with my grandson, which means you can spot a diamond in the rough. But what apples do you like best?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not too sweet. Firm and crisp.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Jonathans, then, and Ida Reds, although I’m not sure you can find them easily. Yorks aren’t so tangy, but you would like them, as well. At one time, we had five hundred or more. Nothing beats a York in the kitchen, although it’s a funny-looking thing. The Pennsylvania Dutch—and we had some around here, you know, although I suppose by rights we’d have to call them Virginia Dutch. Anyway—” she waved her words away “—they called it a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("schepabbel.")]), _vm._v(" Crooked apple. And the cider we made? That pie was from last year’s apple crop. But, of course, today people want apples that look like they’re made out of wax, even if they taste like sawdust.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Granny Grace and Grandpa Ben had an orchard,” Cash explained.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Have")]), _vm._v(". Ben’s gone, of course, God bless him, but the orchard still belongs to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("me")]), _vm._v(".”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We know that,” Cash said. “Nobody’s disputing it.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And nobody’s helping, either.” Her expression belied the words. She didn’t look angry. Jamie characterized the set of her lips as determined.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie didn’t know what was going on, but she intervened, hoping to turn the conversational tide. “There’s an orchard on this property, or at least the remnants of one. I wonder if any part of it can be saved.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You could try pruning the trees over a period of years if the trunk is still firm. And I’ve seen trees topped, just lopped nearly in half, and brought back to life that way, but it takes years, too, and it’s not always successful. Still, if they’re old friends…You do whatever it takes for a friend, don’t you?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They were somebody’s old friends. My brother-in-law’s grandmother Leah lived on this property. Did you know her? Leah Spurlock Jackson?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t recall. I was so busy with the orchard and my children…that’s the way my life went. It races by, you know. Remember "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" if you have a boring day. Boring is the period at the end of a run-on sentence. Meant for a deep breath and a nap.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We don’t have many boring days around here.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As if to prove it, Alison jumped down from her chair. “Ready!”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’ll wait until everybody’s finished,” Jamie told her daughter. “But after you’ve asked to be excused, you may put your shoes on.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“May I be excused?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You may,” Jamie said with a grin.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“May I please be excused, too?” Hannah asked.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes. And as soon as we’ve finished, we’ll join you.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cash caught Jamie’s eye and flashed her a grin. “May I be excused, too, Miss Jamie? I’d like to unload the materials before we go for that walk.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You bet. The sooner that playhouse is finished, the faster my life improves.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Now, tell me about the fawn,” Grace said, once the girls had gone into their bedroom to get ready and Cash was outside. “Exactly what did you see?”")]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The fawn was in the same place Jamie and the girls had left it yesterday. Today, though, it was bleating softly, like a baby lamb.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Girls, you stay here with me,” Jamie said, when they tried to follow Grace and Cash closer. “Too many people will scare the poor thing to death.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It was in exactly the same spot yesterday?” Cash stood behind his grandmother, who got down on her knees.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t think it’s moved,” Jamie said.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grace was kneeling beside the fawn, examining it gently, and Cash backed away to join them, watching his grandmother as he did.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She’s really a wildlife rehabilitator?” Jamie asked. She’d hardly believed it when Grace had told her so at breakfast. “That’s a stroke of luck.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cash spoke softly. “She always says it’s her life’s work to take care of castaways.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A good job, that one.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Uh-huh, if what you’re trying to bring back ought to be rescued. My mother says people who lived around the orchard and beyond always brought injured animals to Granny Grace. I know when I was a boy she let me help raise a trio of baby coons who’d lost their mother to a redbone hound. Eventually, the authorities caught up with her, if you can believe it. Told her unless she had a permit, it was against the law to do what she’d been doing for years.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I guess they’re just trying to protect wildlife from people who don’t know how to help.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She could have taught them a thing or two, but being Granny Grace, she did what she had to and got the training.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grace stood and joined them. “We could leave the poor thing here another day or two, see if the mother comes back. But it’s my opinion that this mother hasn’t returned for some time. No need to go into why I think so—” she glanced at the girls “—but I’d say we’d be in our rights to take this little one up to my house and see what we can do with her. If we leave her, I don’t think she’ll fare well.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cash turned to Jamie. “What do you think?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I was so afraid you were going to tell me I had to take care of her. I don’t have a clue what to do.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grace glanced at the girls again. “It’s a delicate business. Best leave it to me. If things go well, the girls can come up and visit.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hannah had been unusually quiet. “Is she going to die, Granny Grace?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not if I can help it, Hannah. But truth be told, she might.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hannah looked stricken. “I don’t want her to die.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nor do I, which is why I’ll do my level best to help. You can count on me. But you know, child, some things are simply out of our hands. So we can feel sad, but we can’t feel responsible.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie knew that was a lesson every child had to learn, but she was sorry.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The fawn’s very lucky good people found her,” Jamie said, trying to make Hannah feel better. “First Alison spotted her, then Granny Grace came along. And Granny Grace knows how to help, when almost nobody else would. That’s two times so far that fawn’s been lucky.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Lucky,” Alison said. “Her name is Lucky.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie knew naming an animal was the end of objectivity. But this time, objectivity had fled at first glance.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Lucky is a good name,” Grace said. “Good names are important. Cash?” Grace nodded to the fawn. “Let’s get her home right away.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cash bent over and picked up the little deer. She hardly struggled. Jamie knew this wasn’t a good sign.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let Cash and Lucky go first,” she said, holding the girls back.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll have to visit your orchard another day,” Grace said, walking with Jamie and the girls once Cash had strode ahead. The girls were abnormally subdued, as if only now had they realized the gravity of removing the fawn.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I hope you’ll come back as soon as you can,” Jamie said.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“As soon as things stabilize, I’d like you and the girls to come and visit. Will you do that?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You won’t be able to keep us away.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I think we’ll be friends. I’ve been away for some time, and a number of my old friends are gone. So I’ll be happy to have you coming in and out as often as you please.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie was surprised that somebody like Grace could ever be lonely, but she heard a hunger in her new friend’s voice and recognized it. It matched her own. “You may not be so happy if we hit you on a day when the girls are hot, tired and cranky,” she warned.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Even children in fairy tales aren’t always well-behaved.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why did Lucky’s mother leave her?” Hannah asked, as if the question had just occurred to her. “What kind of mother leaves her baby for somebody else to take care of?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll let you answer that,” Grace told Jamie. “I’ll welcome your children into my home, dear, but I’ll be equally thrilled to turn the difficult questions over to you.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie shot her a smile, but as she fumbled through an explanation that didn’t include the dead doe on Fitch Crossing Road, she wondered in how many ways and how often she would have to answer the same question and all its variations if indeed even now she was carrying her sister’s child.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6030745d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781460302989_ch03.vue
// module id = 84
// module chunks = 0